import type { GameThemeFragment } from '~/client/shared/graphql/GameFragment.generated';
import NextLink from '~/client/shared/NextLink';

type Props = { theme?: GameThemeFragment };

const ThemeBadge: FC<Props> = ({ theme }) => (
  <NextLink href={`/themes/${theme?.handle}`}>
    <div className="rounded-3xl bg-gohan px-3 py-1">
      <p className="text-moon-10-caption font-medium uppercase text-bulma">
        <span>#</span>
        {theme?.name}
      </p>
    </div>
  </NextLink>
);

export default ThemeBadge;
